export { useYardTaskByRelatedEntityFetcherV2 } from './useYardTaskByRelatedEntityFetcherV2';
export type {
  UseYardTaskByRelatedEntityFetcherV2Options,
  UseYardTaskByRelatedEntityFetcherV2Options as UseYardTaskByRelatedEntityPresenterV2Options
} from './useYardTaskByRelatedEntityFetcherV2';

import { useYardTaskByRelatedEntityFetcherV2 } from './useYardTaskByRelatedEntityFetcherV2';

import type { UseYardTaskByRelatedEntityFetcherV2Options } from './useYardTaskByRelatedEntityFetcherV2';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardTaskByRelatedEntityFetcherV2}.
 */
export function useYardTaskByRelatedEntityPresenterV2(
  options: UseYardTaskByRelatedEntityFetcherV2Options
) {
  return useYardTaskByRelatedEntityFetcherV2(options);
}
